/* eslint-disable */
import 'amazon-connect-streams';
import {
  API_PATIENTS_COMMENTS,
  API_READINGS_ACTIONS,
  API_CCM_PATIENT_CALL,
} from 'services/dataService/resources';
import { showResult } from 'infrastructure/hooks/utils';
import dataService from '../dataService';
import { SocketRoutes } from 'services/wsService';
import { getDomainName } from 'utils/helpers/get-domain-name';

const AWS_CONNECT_URL_CCP = process.env.REACT_APP_CONNECT_URL_CCP;
const AWS_CONNECT_URL = process.env.REACT_APP_CONNECT_URL;

const contactToPatientMap = {};

const init = () => new Promise((res) => {
  {
    const containerDiv = document.getElementById('connect-el');

    connect.core.initCCP(containerDiv, {
      ccpUrl: AWS_CONNECT_URL_CCP,
      loginUrl: AWS_CONNECT_URL,
      loginPopup: true,
      loginPopupAutoClose: true,
      region: 'us-east-1',
      pageOptions: {
        enableAudioDeviceSettings: false,
        enablePhoneTypeSettings: false,
      },
      softphone: {
        allowFramedSoftphone: true,
        allowEarlyGum: false
      },
    });

    connect.core.onInitialized(() => {
      res()
    })
    connect.core.onAuthFail(() => {
      rej()
    })
  }
});

const makeCall = (
  phoneNumber,
  patientGuid,
  setCallId,
  isRpmCall,
  deviceId,
  readingId,
  wsClient,
  awsRumAgent,
  isReadOnlyRole,
) => {
  if (phoneNumber) {
    connect.agent((agent) => {
      const endpoint = connect.Endpoint.byPhoneNumber(phoneNumber);
      agent.connect(endpoint);
    });

    connect.contact((contact) => {
      contact.onConnecting(async (event) => {
        console.log('onConnectingContact', contact);
        console.log('onConnectingEvent', event);
        console.log('onConnectingContactIsInbound', contact.isInbound());
        console.log('onConnectingEventIsInbound', event.isInbound());
        if (event.isInbound()) return;
        if (!patientGuid) return;

        const { contactId } = event;
        setCallId(contactId);
        awsRumAgent.recordEvent('callConnecting', {
          patientGuid,
          phoneNumber,
          contactId,
        });
        let callData = {};
        callData = { patientGuid };

        contactToPatientMap[contactId] = patientGuid;
        wsClient.send(SocketRoutes.OnCallStarted, { patientGuid, isRpmCall });

        if (isRpmCall) {
          callData = {
            ...callData,
            deviceId,
            readingId,
            type: 'call',
            message: contactId,
            commentType: 'rpm',
          };
        } else {
          callData = {
            ...callData,
            callId: contactId,
          };
        }

        if (!isReadOnlyRole) {
          const { error } = await dataService.createOne(
            !isRpmCall
              ? API_CCM_PATIENT_CALL
              : deviceId && readingId
                ? API_READINGS_ACTIONS
                : API_PATIENTS_COMMENTS,
            callData,
          );

          if (error) showResult(error);
        }

        patientGuid = null;
      });

      contact.onDestroy(async (event) => {
        if (event.isInbound()) return;
        const { contactId } = event;
        const currentPatientGuid = contactToPatientMap[contactId];
        if (currentPatientGuid) {
          awsRumAgent.recordEvent('callDestroyed', {
            patientGuid: currentPatientGuid,
            contactId,
          });
          wsClient.send(SocketRoutes.OnCallEnded, {
            patientGuid: currentPatientGuid,
            isRpmCall,
          });
        }
      });

      contact.onEnded(async (event) => {
        if (event.isInbound()) return;
        const { contactId } = event;
        const currentPatientGuid = contactToPatientMap[contactId];
        if (currentPatientGuid) {
          awsRumAgent.recordEvent('callDestroyed', {
            patientGuid: currentPatientGuid,
            contactId,
          });
          wsClient.send(SocketRoutes.OnCallEnded, {
            patientGuid: currentPatientGuid,
            isRpmCall,
          });
        }
      });
    });
  }
}

const endCall = () => {
  connect.agent((agent) => {
    const [contact] = agent.getContacts();
    if (contact) {
      const activeContactConnection = contact.getAgentConnection();
      activeContactConnection.destroy();
    }
  });
}

const terminate = () => {
  connect.core.terminate();
  const containerDiv = document.getElementById('connect-el');
  if (containerDiv) {
    const iframe = containerDiv.firstElementChild;
    if (iframe)
      containerDiv.removeChild(iframe);
  }
};

const setAgentOffline = () => {
  return new Promise((resolve, reject) => {
    const agent = new connect.Agent();
    const offlineState = agent
      .getAgentStates()
      .find((state) => state.type === connect.AgentStateType.OFFLINE);
    agent.setState(
      offlineState,
      { success: resolve, failure: reject },
      { enqueueNextState: true },
    );
  });
};

function handleLogout() {
  const logoutEndpoint = `https://${getDomainName(AWS_CONNECT_URL_CCP)}/logout`;
  fetch(logoutEndpoint, { credentials: 'include', mode: 'no-cors' }).then(
    () => {
      connect.core.getUpstream().sendUpstream(connect.EventType.TERMINATE);
    },
  );
}


const logout = () =>
  new Promise((res) => {
    setAgentOffline().then(handleLogout).catch(console.error);
    const eventBus = connect.core.getEventBus();
    eventBus.subscribe(connect.EventType.TERMINATED, () => {
      terminate()
      res()
    });
  });

export {
  init,
  terminate,
  logout,
  makeCall,
  endCall,
};
